// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material/material.module';
import { TranslateModule } from '@ngx-translate/core';

// components
import { UnauthorizedPageComponent } from 'app/shared/pages/error/unauthorized-page.component';

// modules
import { LayoutModule } from 'app/shared/layout/layout.module';

// services
import { StoredFileService } from 'app/shared/services/stored-file.service';
import { CriterionService } from 'app/shared/services/criterion.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    LayoutModule,
    TranslateModule
  ],
  declarations: [
    UnauthorizedPageComponent
  ],
  providers: [
    StoredFileService,
    CriterionService,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts